var _defs, _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartonMauvaisePosition3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "positions_porter_carton",
    "data-name": "positions porter carton",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 497 737.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#fff;stroke-miterlimit:10;stroke-width:6px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mauvaise r\xE9ponse 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 622,
    y: 719,
    width: 236,
    height: 158,
    transform: "translate(-739.65 -368.54) rotate(-20.74)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 418,
    cy: 208.67,
    r: 79
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814,863c-38.61-11.36-255.5,123.5-270,138s-36,401-36,401c0,20.36,53,20.36,53,0l45-222,30,222c0,20.36,55,20.36,55,0l-27-326,127-90s92.5,13.5,97.5-1.5-19-161-19-161C864,803,832,808,832,828a950.6,950.6,0,0,0,8,112C839,872,831,868,814,863Z",
    transform: "translate(-505 -682.33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M814,863c-38.61-11.36-255.5,123.5-270,138s-36,401-36,401c0,20.36,53,20.36,53,0l45-222,12-69,46-35,127-90s92.5,13.5,97.5-1.5-19-161-19-161C864,803,832,808,832,828a950.6,950.6,0,0,0,8,112C839,872,831,868,814,863Z",
    transform: "translate(-505 -682.33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M837.5,873.5C835.58,877,842,933,844,957c.63,7.61-9,1-9,1l16,27,6-60-14-51S840,869,837.5,873.5Z",
    transform: "translate(-505 -682.33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartonMauvaisePosition3);
export default __webpack_public_path__ + "static/media/carton_mauvaise_position_3.00ee554bb2defd4242f378d07906099d.svg";
export { ForwardRef as ReactComponent };